module.exports = __webpack_public_path__ + "static/media/next1.f57d578c.svg";